/**
 * Based on https://github.com/bushblade/react-touch-drag-slider
 */

import React, { FC, ForwardedRef } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components/macro"

type SlideProps = {
  child?: any
  className?: string
  gap?: {
    default?: number
    lg?: number
    md?: number
  }
  onDragStart?: any
  ref?: any
  width?: {
    default?: number
    lg?: number
    md?: number
  }
}

export const SlideItem = styled.div<SlideProps>`
  /* stylelint-disable */
  display: block;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;
`

export const SlideWrapper = styled.div<SlideProps>`
  transition: transform 0.2s ease-out;
  position: relative;
  width: auto;
  max-width: ${(props) =>
    props?.width?.default && props?.gap?.default
      ? props.width.default + props.gap.default + "px"
      : "125px"};
  padding: ${(props) =>
    props?.gap?.default ? "0px " + props.gap.default + "px" : "0px 8px"};
  ${up("md")} {
    max-width: ${(props) =>
      props?.width?.md && props?.gap?.md
        ? props.width.md + props.gap.md + "px"
        : "150px"};
    padding: ${(props) =>
      props?.gap?.md ? "0px " + props.gap.md + "px" : "0px 12px"};
  }
  ${up("lg")} {
    max-width: ${(props) =>
      props?.width?.lg && props?.gap?.lg
        ? props.width.lg + props.gap.lg + "px"
        : "190px"};
    padding: ${(props) =>
      props?.gap?.lg ? "0px " + props.gap.lg + "px" : "0px 20px"};
  }
`

export const Slide: FC<SlideProps> = React.forwardRef(
  (props: SlideProps, ref: ForwardedRef<string>) => {
    const classes = props.className || ""

    return (
      <SlideWrapper
        className={classes + " SlideStyles"}
        gap={props.gap}
        ref={ref}
        width={props.width}>
        <SlideItem
          onDragStart={(event: any) => {
            event.preventDefault()
            event.stopPropagation()
            return false
          }}
          className="slide-inner"
          unselectable="on">
          {props.child}
        </SlideItem>
      </SlideWrapper>
    )
  },
)

export default Slide
